import { render, staticRenderFns } from "./webProxy.vue?vue&type=template&id=b4924ba6&scoped=true"
import script from "./webProxy.vue?vue&type=script&lang=js"
export * from "./webProxy.vue?vue&type=script&lang=js"
import style0 from "./webProxy.vue?vue&type=style&index=0&id=b4924ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4924ba6",
  null
  
)

export default component.exports